import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

 gsap.registerPlugin(ScrollTrigger);

export default function initFixedFooterSection() {
  let mm = gsap.matchMedia();
  let breakPoint = 1024;

  
  const footer = document.querySelector('.footer');
  const footerWrap = document.querySelector('.footer-wrap');
  let oldWidth = window.innerWidth;
  const controlPanel = document.querySelector('.control-panel');

  mm.add(
  {
    // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
    isDesktop: `(min-width: ${breakPoint}px)`,
    isMobile: `(max-width: ${breakPoint - 1}px)`,
    reduceMotion: "(prefers-reduced-motion: reduce)",
  },
  (context) => {
    // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
    let { isDesktop, isMobile, reduceMotion } = context.conditions;
    const scene = gsap.from(footer, {y: isDesktop ? -footer.clientHeight / 2 : -footer.clientHeight / 4, ease: 'none'});
  
    let trigger = ScrollTrigger.create({
      trigger: footerWrap,
      start: 'top bottom',
      end: 'bottom bottom',
      animation: scene,
      // markers: true,
      scrub: true,
      onEnter: ()=> {
        console.log('start')
        if(controlPanel) {
          controlPanel.classList.add('white');
        }
      },
      onLeaveBack: ()=> {
        console.log('end')
         if(controlPanel) {
          controlPanel.classList.remove('white');
         }
      }
    });
    let resizeTrigger;
  
    window.addEventListener('resize', ()=>{
      clearTimeout(resizeTrigger);
      resizeTrigger = setTimeout(()=> {
        if(oldWidth === window.innerWidth) return;
        trigger.refresh();
        oldWidth = window.innerWidth;
      }, 500);
    })
   

    return () => {
      // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
      // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
    };
  });
}
